import { render } from "./Breadcrumbs.vue?vue&type=template&id=8d9e63b0&scoped=true"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js"

import "./Breadcrumbs.vue?vue&type=style&index=0&id=8d9e63b0&scoped=true&lang=css"

import exportComponent from "D:\\Front-end\\Beetronix\\alradwan-frontend\\vue-1\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d9e63b0"]])

export default __exports__